import { Inject } from '@angular/core';
import '@angular/compiler';
import { PagePosSalesReceiptComponent } from './page.pos.sales.receipt/page.pos.sales.receipt.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PagePosSalesMenuComponent } from './page.pos.sales.menu/page.pos.sales.menu.component';
import { PageStartComponent } from './page.start/page.start.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PagePosBusinessComponent } from './page.pos.business/page.pos.business.component';
import { PagePosSettingsComponent } from './page.pos.settings/page.pos.settings.component';
import { PagePosSalesStatusComponent } from './page.pos.sales.status/page.pos.sales.status.component';
import { PagePosOrdersComponent } from './page.pos.orders/page.pos.orders.component';
import { LayoutPosComponent } from './layout.pos/layout.pos.component';
import { PagePosSalesComponent } from './page.pos.sales/page.pos.sales.component';
import { PagePosCustomerComponent } from './page.pos.customer/page.pos.customer.component';
import { PagePosRevenueComponent } from './page.pos.revenue/page.pos.revenue.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PagePosComponent } from './page.pos/page.pos.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PagePosSalesReceiptComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalSeasonFormDropdownComponent,
        PagePosSalesMenuComponent,
        PageStartComponent,
        PortalSeasonModalComponent,
        PortalSeasonTreeComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonPaginationComponent,
        PagePosBusinessComponent,
        PagePosSettingsComponent,
        PagePosSalesStatusComponent,
        PagePosOrdersComponent,
        LayoutPosComponent,
        PagePosSalesComponent,
        PagePosCustomerComponent,
        PagePosRevenueComponent,
        LayoutEmptyComponent,
        PagePosComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }